import { render, staticRenderFns } from "./CenterLayout.vue?vue&type=template&id=05ff2afc&scoped=true&"
import script from "./CenterLayout.vue?vue&type=script&lang=js&"
export * from "./CenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./CenterLayout.vue?vue&type=style&index=0&id=05ff2afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff2afc",
  null
  
)

export default component.exports